import React, { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';

const float = keyframes`
  0%, 100% { transform: translateY(0) translateX(0); opacity: 0.35; }
  50% { transform: translateY(-18px) translateX(6px); opacity: 0.85; }
`;

export default function FloatingParticles({ count = 24 }) {
	const particles = useMemo(
		() =>
			Array.from({ length: count }, (_, i) => ({
				id: i,
				left: `${(i * 37 + 11) % 100}%`,
				top: `${(i * 53 + 7) % 100}%`,
				size: 2 + (i % 3),
				delay: `${(i % 8) * 0.7}s`,
				duration: `${5 + (i % 5) * 1.2}s`,
				color: i % 3 === 0 ? '#22d3ee' : i % 3 === 1 ? '#a78bfa' : '#60a5fa',
			})),
		[count],
	);

	return (
		<Box position='absolute' inset={0} overflow='hidden' pointerEvents='none' aria-hidden>
			{particles.map((p) => (
				<Box
					key={p.id}
					position='absolute'
					left={p.left}
					top={p.top}
					w={`${p.size}px`}
					h={`${p.size}px`}
					borderRadius='full'
					bg={p.color}
					boxShadow={`0 0 ${p.size * 3}px ${p.color}`}
					animation={`${float} ${p.duration} ease-in-out infinite`}
					sx={{ animationDelay: p.delay }}
				/>
			))}
		</Box>
	);
}
